import routerOptions0 from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}